export default __webpack_public_path__ + "static/media/plurall-smile.fede7924.svg";